import * as gamesAPI from "../api/games.api";
import * as gamesConst from "../const/games.const";

export function getGames() {
  return {
    type: gamesConst.GET_GAMES,
    payload: gamesAPI.fetchGames()
  };
}

export function getRandomGames() {
  return {
    type: gamesConst.GET_R_GAMES,
    payload: gamesAPI.fetchRandomGames()
  };
}

export function getGameImages(id) {
  return {
    type: gamesConst.GET_GAME_IMAGES,
    payload: gamesAPI.fetchGameImages(id)
  };
}
